export const PRIMARY = '#985709';
export const SECONDARY = '#fec817';
export const WHITE = '#fff'
export const LIGHT = '#f8f8f8';
export const DARK = '#000000';
export const GRAY = '#565656';
export const TRANSPARENT = "rgba(255, 255, 255, 0.2)";
export const TRANSPARENT_DARK = "rgba(0, 0, 0, 0.2)";
